import PlayerCard from "../../components/PlayerLookup Components/PlayerCard";
import SearchBar from "../../components/PlayerLookup Components/LookupSearchBar";
import { useState, useEffect } from "react";
import WalletCard from "../../components/PlayerLookup Components/WalletCard";
import PetsLands from "../../components/PlayerLookup Components/PetsLands";
import ListingsCard from "../../components/PlayerLookup Components/ListingsCard";
import AccountDetails from "../../components/PlayerLookup Components/AccountDetails";
import { useParams } from "react-router";

function useScreenSize() {
  const [screen, setScreen] = useState("mobile");

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      if (width < 768) setScreen("mobile"); // Tailwind md: 768px
      else if (width < 1024) setScreen("medium"); // Tailwind lg: 1024px
      else setScreen("large");
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return screen;
}

const PlayerLookup = () => {
  const [playerData, setPlayerData] = useState(null);
  const { playerId } = useParams();
  const screen = useScreenSize();

  return (
    <div className="max-h-full relative panel-style">
      {/* Content Container */}
      <div className="relative flex flex-col items-center w-full">
        {/* Search Bar Container */}
        <div className="w-full max-w-4xl px-4 py-8 md:py-5 flex justify-center">
          <SearchBar onSearch={setPlayerData} initialSearchQuery={playerId} />
        </div>

        {/* Player Info Cards */}
        {playerData && (
          <div className="w-full max-w-7xl mx-auto px-4">
            {screen === "mobile" && (
              <div className="flex flex-col gap-4">
                <PlayerCard player={playerData} />
                <AccountDetails player={playerData} />
                <WalletCard player={playerData} />
                <ListingsCard player={playerData} />
                <PetsLands playerData={playerData} />
              </div>
            )}

            {screen === "medium" && (
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-4">
                  <PlayerCard player={playerData} />
                  <WalletCard player={playerData} />
                </div>
                <div className="flex flex-col gap-4">
                  <AccountDetails player={playerData} />
                  <ListingsCard player={playerData} />
                  <PetsLands playerData={playerData} />
                </div>
              </div>
            )}

            {screen === "large" && (
              <div className="grid grid-cols-3 gap-4">
                <div className="flex flex-col gap-4">
                  <AccountDetails player={playerData} />
                  <ListingsCard player={playerData} />
                </div>
                <div className="flex flex-col gap-4">
                  <PlayerCard player={playerData} />
                  <div className="invisible">
                    <div className="h-[calc(100%-theme(space.4))]"></div>
                  </div>
                </div>
                <div className="flex flex-col gap-4">
                  <WalletCard player={playerData} />
                  <PetsLands playerData={playerData} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerLookup;
